import { useLanguage } from "@/context/LanguageContext";

const BG =
  "https://images.unsplash.com/photo-1696418800218-6f3bb0975d3b?crop=entropy&cs=srgb&fm=jpg&q=55&w=1000";

export default function CtaBand() {
  const { t } = useLanguage();
  const c = t.cta_band;
  return (
    <section
      className="relative isolate overflow-hidden bg-[#0A0A0A] py-20 text-white md:py-28"
      data-testid="cta-band-section"
    >
      <div
        className="absolute inset-0 -z-10 bg-cover bg-center opacity-60"
        style={{ backgroundImage: `url(${BG})` }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 -z-10 bg-gradient-to-r from-black/85 via-black/65 to-black/30" />

      <div className="mx-auto flex max-w-7xl flex-col items-start gap-8 px-6 md:flex-row md:items-end md:justify-between md:px-10">
        <div className="max-w-2xl">
          <h2
            className="text-4xl leading-[1.05] tracking-tight md:text-6xl"
            style={{ fontFamily: "Fraunces, serif" }}
            data-testid="cta-band-title"
          >
            {c.title}
          </h2>
          <p className="mt-5 max-w-xl text-base text-white/80 md:text-lg">
            {c.sub}
          </p>
        </div>
        <a
          href="#activities"
          data-testid="cta-band-button"
          className="inline-flex items-center gap-3 rounded-full bg-[#FF5533] px-8 py-4 text-sm font-semibold uppercase tracking-wider text-white shadow-2xl shadow-[#FF5533]/30 transition-all hover:-translate-y-0.5 hover:bg-[#E64A2B]"
        >
          {c.button} →
        </a>
      </div>
    </section>
  );
}
